import { queryOptions } from '@tanstack/react-query';

import { api } from './api.js';



export type Range = '1d' | '7d' | '30d' | '90d' | '365d';



export interface Overview {

  range: { days: number };

  totals: {

    sent: number;

    delivered: number;

    opens: number;

    clicks: number;

    bounces: number;

    complaints: number;

    unsubscribes: number;

    machineOpens: number;

  };

  /** null, wenn nichts versendet wurde — nicht 0. */

  rates: {

    openRate: number | null;

    clickRate: number | null;

    bounceRate: number | null;

    complaintRate: number | null;

    unsubscribeRate: number | null;

  };

  series: Array<{ tag: string; sent: number; opens: number; clicks: number }>;

}



export const overviewQuery = (range: Range) =>

  queryOptions({

    queryKey: ['analytics', 'overview', range],

    queryFn: ({ signal }) => api.get<Overview>(`/api/analytics/overview?range=${range}`, signal),

    staleTime: 30_000,

  });



export interface DomainRow {

  domain: string;

  sent: number;

  opens: number;

  bounces: number;

  complaints: number;

  openRate: number | null;

  bounceRate: number | null;

}



export const domainsQuery = (range: Range) =>

  queryOptions({

    queryKey: ['analytics', 'domains', range],

    queryFn: ({ signal }) =>

      api.get<{ items: DomainRow[] }>(`/api/analytics/domains?range=${range}`, signal),

    staleTime: 30_000,

  });



export const linksQuery = (range: Range) =>

  queryOptions({

    queryKey: ['analytics', 'links', range],

    queryFn: ({ signal }) =>

      api.get<{ items: Array<{ url: string; clicks: number; contacts: number }> }>(

        `/api/analytics/links?range=${range}`,

        signal,

      ),

    staleTime: 30_000,

  });



export const engagementQuery = (range: Range) =>

  queryOptions({

    queryKey: ['analytics', 'engagement', range],

    queryFn: ({ signal }) =>

      api.get<{

        items: Array<{

          id: string;

          email: string;

          opens: number;

          clicks: number;

          leadScore: number;

        }>;

      }>(`/api/analytics/engagement?range=${range}`, signal),

    staleTime: 30_000,

  });



/**

 * Anteil als Prozentangabe.

 *

 * null bleibt ein Gedankenstrich. Eine Rate ohne Grundmenge als „0 %"

 * anzuzeigen behauptet eine Messung, die es nicht gab.

 */

export function percent(value: number | null | undefined, digits = 1): string {

  if (value === null || value === undefined) return '—';

  return `${(value * 100).toFixed(digits)} %`;

}

